export default {"src":"/_next/static/media/shareV2.68dd191d.svg","height":5,"width":23,"blurWidth":0,"blurHeight":0};